import { env } from "@/lib/env/client";

/**
 * Client-side Google Ads conversion tracking for outbound clicks.
 *
 * Fires a gtag conversion event and pushes to the GTM dataLayer when
 * NEXT_PUBLIC_GADS_CONVERSION_ID and NEXT_PUBLIC_GADS_CONVERSION_LABEL
 * are configured. No-ops silently when the vars are absent so non-TrustedReviews
 * deployments are unaffected.
 *
 * Consent gating is handled automatically by GTM Consent Mode v2 — when
 * ad_storage is denied, gtag queues the event and only sends it once the user
 * grants consent.
 *
 * NOTE: No value/currency is sent with the conversion. Actual revenue is
 * reported separately via offline conversion imports once affiliate commissions
 * are known.
 */
export function fireOutboundConversion(): void {
  const conversionId = env.NEXT_PUBLIC_GADS_CONVERSION_ID;
  const conversionLabel = env.NEXT_PUBLIC_GADS_CONVERSION_LABEL;
  if (!conversionId || !conversionLabel) return;

  window.gtag?.("event", "conversion", {
    send_to: `${conversionId}/${conversionLabel}`,
  });

  window.dataLayer?.push({
    event: "outbound_click_conversion",
    conversionId,
    conversionLabel,
  });
}
